import React, { useState, useEffect } from 'react'
import { Box, Heading, Spinner } from 'grommet'
import PropTypes from 'prop-types'
import ProjectCard from '../../components/BugfixProjectCard'
import cloneDeep from 'lodash/cloneDeep'
import { API } from '../../libs/amplifyAPI'

const renderBugfixProjects = ({ bugfixProjects, fetchBugfixListInProgress, toggleBug }) => {
  if (fetchBugfixListInProgress) {
    return (<Box align='center'><Spinner size='80px'/></Box>)
  }
  if (!bugfixProjects.length) {
    return (
      <Box align='center'>No projects!</Box>
    )
  } else {
    return (
      <Box align='center'>
        {bugfixProjects.map((project, index) => (
          <ProjectCard key={project._id} project={project} toggleBug={toggleBug} projectIndex={index} />
        ))}
      </Box>
    )
  }
}

const BugfixOperations = () => {
  const [bugfixList, setBugfixList] = useState([])
  const [fetchBugfixListInProgress, setFetchBugfixListInProgress] = useState(true)

  useEffect(() => {
    API.get('LocmanUI', 'bugfixes')
      .then(res => {
        let updatedBugfixList = res.map(project => {
          project.bugs.forEach(bug => (bug.expanded = false))
          return project
        })
        setBugfixList(updatedBugfixList)
        setFetchBugfixListInProgress(false)
      })
      .catch(err => {
        console.log(err)
        setFetchBugfixListInProgress(false)
      })
  }, [])

  const toggleBug = (project, bug) => {
    const updatedBugfixList = cloneDeep(bugfixList)
    updatedBugfixList[project].bugs[bug].expanded = !updatedBugfixList[project].bugs[bug].expanded
    setBugfixList(updatedBugfixList)
  }

  return (
    <Box align='stretch' fill='horizontal' jusify='center'>
      <Box align='center'><Heading level='2'>Bugfix Projects</Heading></Box>
      {renderBugfixProjects({
        bugfixProjects: bugfixList,
        fetchBugfixListInProgress,
        toggleBug
      })}
    </Box>
  )
}

BugfixOperations.propTypes = {
  bugfixList: PropTypes.array
}

export default BugfixOperations